import { useDispatch, useSelector } from "react-redux";
import { UIRootState } from "ui/store";
import './styles.css';
import { translate } from "game/translate";
import { RewardType } from "game/quests/types";
import { useCallback, useMemo } from "react";
import { closeMissionCompletePopup } from "ui/store/actions/gameUIActions";
import { GAEvent, GAEventNames } from "game/analytics/events";

export const MissionCompletePopup: React.FC = () => {
    const dispatch = useDispatch();

    const isOpen = useSelector((state: UIRootState) => state.gameUI.modals.missionCompletePopup.isOpen);
    const dailyMission = useSelector((state: UIRootState) => state.gameUI.missions.dailyMission);
    const placement = useSelector((state: UIRootState) => state.gameUI.modals.missionCompletePopup.placement);

    const wandRewardAmount = useMemo(() => dailyMission?.rewards.find((reward) => reward.type === RewardType.MAGIC_WAND)?.amount || 0, [dailyMission]);
    const wandAdRewardAmount = useMemo(() => dailyMission?.rewards.find((reward) => reward.type === RewardType.MAGIC_WAND)?.adAmount || 0, [dailyMission]);
    
    const hintRewardAmount = useMemo(() => dailyMission?.rewards.find((reward) => reward.type === RewardType.HINTS)?.amount || 0, [dailyMission]);
    const hintAdRewardAmount = useMemo(() => dailyMission?.rewards.find((reward) => reward.type === RewardType.HINTS)?.adAmount || 0, [dailyMission]);

    const chestIconName = useMemo(() => dailyMission?.isAdditionalMission ? 'big_claimed_chest_secondary' : 'big_claimed_chest', [dailyMission]);

    const handleButtonClick = (buttonKey: string, data?: any) => {
        document.dispatchEvent(new CustomEvent('ui-button-click', {
          detail: { buttonKey, data }
        }));
      };
    
    const handleContinueButtonClick = useCallback(() => {
        if (placement === 'winscreen') {
            handleButtonClick('win-popup-mission-continue-btn');
        }
        GAEvent(GAEventNames.MISSION_REWARD_CONTINUE);
        dispatch(closeMissionCompletePopup());
    }, [dispatch, placement]);

    if (!isOpen) {
        return null;
    }

    return (
        <div className="mission-complete-popup">
            <div className="mission-complete-popup-content">
                <div className="mission-complete-popup-content-header">
                    <span className="mission-complete-popup-content-header-text">{translate('congrats_daily_text')}</span>
                    <span className="mission-complete-popup-content-header-text-secondary">{translate('congrats_daily_text_secondary')}</span>
                </div>

                <div className="mission-complete-popup-content-icons">   
                    <div className="mission-complete-popup-content-rewards">
                        <div className="mission-complete-popup-content-reward">
                            <picture>
                                <source srcSet='/assets/missions/wand_reward_icon.webp' type="image/webp" />
                                <img className="mission-complete-popup-content-reward-icon" src='/assets/missions/wand_reward_icon.png'/>
                            </picture>
                            <picture>
                                <source srcSet='/assets/missions/reward_glow.webp' type="image/webp" />
                                <img className="mission-complete-popup-content-reward-glow" src='/assets/missions/reward_glow.png'/>
                            </picture>

                            <span className="mission-complete-popup-content-reward-amount">x{dailyMission?.isAdditionalMission ? wandAdRewardAmount : wandRewardAmount}</span>
                        </div>

                        <div className="mission-complete-popup-content-reward">
                            <picture>
                                <source srcSet='/assets/missions/hint_reward_icon.webp' type="image/webp" />
                                <img className="mission-complete-popup-content-reward-icon" src='/assets/missions/hint_reward_icon.png'/>
                            </picture>
                            
                            <picture>
                                <source srcSet='/assets/missions/reward_glow.webp' type="image/webp" />
                                <img className="mission-complete-popup-content-reward-glow" src='/assets/missions/reward_glow.png'/>
                            </picture>

                            <span className="mission-complete-popup-content-reward-amount">x{dailyMission?.isAdditionalMission ? hintAdRewardAmount : hintRewardAmount}</span>
                        </div>
                    </div>
                </div>

                <div className="mission-complete-popup-content-footer">
                    <img className="mission-complete-popup-content-chest-icon" src={`/assets/missions/${chestIconName}.png`}/>
                    <div id="closing-ignore-el" onClick={handleContinueButtonClick} className="mission-complete-popup-content-continue-button">
                        <span id="closing-ignore-el" className="mission-complete-popup-content-continue-button-text">{translate('congrats_daily_button_text')}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};